// extracted by mini-css-extract-plugin
export default {"news":"index_news_GFapH","newsBoxItem":"index_newsBoxItem_P1sf6"};